import React, {Component} from 'react';
import Layout from '../components/Layout';
import Banner from '../components/Banner';
import MenuCaldas from '../components/MenuCaldas';
import Sponsors from '../components/Sponsors';
import GalleryComponent from '../components/GalleryComponent';

class GalleryCaldas extends Component{
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      data: {},
    }
  }

  componentDidMount() {
    fetch('https://legendofeldorado.com/series-admin-temporal/api/gallery_race/caldas')
    .then(res => res.json())
    .then(
      (res) => {
        this.setState({
          isLoaded: true,
          data: res,
        });
      },

      (error) => {
        this.setState({
          isLoaded: true,
          error
        });
      }
    )

  }

  render(){
    const { photos, sponsors } = this.state.data;

    return(
      <Layout>
        <Banner id={13} city="caldas" thumb="/caldas/logo_caldas.png" />
        <MenuCaldas />
        <div className="row content-caldas">
          <div className="container" id="contenido_video">
            <div className="row">
              <div className="col-12">
                {photos && 
                  <GalleryComponent city="caldas" images={photos}/>
                }
              </div>
            </div>
          </div>
        </div>
        {sponsors && 
          <Sponsors
          customClass="--caldas"
          items={sponsors}
          />
        }
      </Layout>
      )
    }
  }

export default GalleryCaldas;
